module.exports = __webpack_public_path__ + "static/img/optiwatt_logo.d24b4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/optiwatt_logo.png
// module id = fYy5
// module chunks = 0